import React, { useContext } from 'react';
import '../../assets/Modal.css';
import '../../assets/header.css';
import { AuthContext } from "../../store/AuthProvider";

const HeaderSettingModal = ({ closeModal }) => {
    const { isAuthenticatedProvider, logout } = useContext(AuthContext);
    
    // 根據環境決定博客連結
    const blogUrl = process.env.NODE_ENV === 'production'
        ? 'https://blog.stemcellsoft.com'
        : 'http://blog.localhost:3000';

    // 鐵灰設計樣式
    const ironGreyStyle = {
        color: '#4a4a4a',
        transition: 'all 0.3s ease'
    };

    return (
        <div className="modal" onClick={closeModal}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <div className="close" onClick={closeModal}>
                    &times;
                </div>

                <div className='header-profile-title mt-4'>功能</div>
                <ul className='modal-menu'>
                    <a className="remove-link-css" href='/a?id=1'>
                        <li style={ironGreyStyle}>
                            <i className="icon-lightbulb fa-regular fa-user me-2"></i>
                            <span>About Me</span>
                        </li>
                    </a>
                    
                    <a 
                        className="remove-link-css" 
                        href={blogUrl} 
                        rel="noopener noreferrer"
                    >
                        <li style={ironGreyStyle}>
                            <i className="icon-lightbulb fa-solid fa-blog me-2"></i>
                            <span>Blog</span>
                        </li>
                    </a>
                </ul>
            </div>
        </div>
    );
};

export default HeaderSettingModal;
